import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FortalezasDebilidadesPage } from './fortalezas-debilidades';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    FortalezasDebilidadesPage,
  ],
  imports: [
    IonicPageModule.forChild(FortalezasDebilidadesPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
    DirectivesModule
  ],
})
export class FortalezasDebilidadesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/fortalezas-debilidades/fortalezas-debilidades.module.ts